import { Injectable } from '@angular/core'
import { HttpService, ICompareWithSelection } from '@mg-platform/core/core-data-access'
import { Observable } from 'rxjs'
import { DASHBOARD_API_URL } from './dashboard-api-routes'
import {
  IDashboardCarsAvgTicketTiresTrendsResponse,
  IDashboardSalesTrendsResponse
} from './interfaces/dashboard-average-trends.inteface'
import { IDashboardBenchmarkSalesResponse } from './interfaces/dashboard-benchmark-sales.interface'
import { IDashboardLaborResponse } from './interfaces/dashboard-labor.inteface'
import { IDashboardGrossProfitResponse } from './interfaces/dashboard-gross-profit.inteface'
import { IDashboardGoalsResponse } from './interfaces/dashboard-goals.inteface'
import { IDashboardRankingResponse } from './interfaces/dashboard-ranking.inteface'
import { IDashboardAllResponse } from './interfaces/dashboard-all.inteface'

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  constructor(private http: HttpService) {}

  getSalesTrend(): Observable<IDashboardSalesTrendsResponse> {
    return this.http.get(DASHBOARD_API_URL.salesTrend)
  }

  getCarsAvgTicketTiresTrend(): Observable<IDashboardCarsAvgTicketTiresTrendsResponse> {
    return this.http.get(DASHBOARD_API_URL.carsAvgTicketTiresTrend)
  }

  getBenchmarkSales(
    payload: Partial<ICompareWithSelection>
  ): Observable<IDashboardBenchmarkSalesResponse> {
    return this.http.post(DASHBOARD_API_URL.benchmarkSales, payload)
  }

  getLabors(payload: Partial<ICompareWithSelection>): Observable<IDashboardLaborResponse> {
    return this.http.post(DASHBOARD_API_URL.labor, payload)
  }

  getGrossProfit(payload: Partial<ICompareWithSelection>): Observable<IDashboardGrossProfitResponse> {
    return this.http.post(DASHBOARD_API_URL.grossProfit, payload)
  }

  getGoals(payload: Partial<ICompareWithSelection>): Observable<IDashboardGoalsResponse> {
    return this.http.post(DASHBOARD_API_URL.goals, payload)
  }

  getRanking(payload: Partial<ICompareWithSelection>): Observable<IDashboardRankingResponse> {
    return this.http.post(DASHBOARD_API_URL.ranking, payload)
  }

  getAll(payload: Partial<ICompareWithSelection>): Observable<IDashboardAllResponse> {
    return this.http.post(DASHBOARD_API_URL.all, payload)
  }
}
